<template>
  <div class="add-article">
    <el-form ref="form" :model="question" :rules="rules" label-width="80px">
      <el-form-item label="试题类型" prop="questionType">
        <el-select v-model="question.questionType" style="width:100%" placeholder="请选择试题类型">
          <el-option
            v-for="item in questionTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="问题" prop="question">
        <el-input type="textarea" v-model="question.question" placeholder="请输入问题"></el-input>
      </el-form-item>
      <el-form-item label="选项" prop="options" v-if="showOptions">
        <el-input
          v-for="(item,index) in question.options"
          :key="index"
          v-model="question.options[index]"
        ></el-input>
        <el-button type="primary" plain @click="addNewOption">添加新选项</el-button>
      </el-form-item>
      <el-form-item label="参考答案" prop="answer">
        <el-input type="textarea" v-model="question.answer" placeholder="请输入参考答案"></el-input>
      </el-form-item>
      <el-form-item label="分值" prop="score">
        <el-input type="number" v-model="question.score" placeholder="请输入题目分值"></el-input>
      </el-form-item>
      <el-form-item label="参考时间" prop="time">
        <el-input type="number" v-model="question.time" placeholder="请输入答题参考时间，单位分钟"></el-input>
      </el-form-item>
      <el-form-item style="text-align: right">
        <el-button type="primary" @click="addPreview">加入预览</el-button>
      </el-form-item>
    </el-form>
    <div class="preview-title">试卷预览</div>
    <el-divider />
    <el-form ref="examForm" :model="exam" :rules="rules" label-width="80px">
      <el-form-item label="试卷类型" prop="examType">
        <el-select v-model="exam.examType" style="width:100%" placeholder="请选择">
          <el-option
            v-for="item in examTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="试卷标题" prop="examTitle">
        <el-input type="text" v-model="exam.examTitle" placeholder="如 第三次国科前端测试"></el-input>
      </el-form-item>
      <el-form-item label="开卷时间" prop="date">
        <el-date-picker
          v-model="exam.date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="参考总分">{{exam.totalScores || 0}}分</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="参考时间">{{exam.time || 0}}分钟</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16" :offset="4">
          <div class="preview-title sub">试题</div>
          <div
            v-for="(item,index) in exam.questionList"
            :key="index"
            style="margin-bottom:10px;border-bottom:1px solid #eee"
          >
            <el-form-item label="Question:">
              <pre v-if="!isEdit">{{item.question}}</pre>
              <el-input v-else type="textarea" v-model="item.question" placeholder="请输入问题"/>
            </el-form-item>
            <el-form-item
              label="Option:"
              v-for="(_item,index) in item.options"
              :key="index"
            >{{_item}}</el-form-item>
            <el-form-item label="Answer:">
              <pre v-if="!isEdit">{{item.answer}}</pre>
              <el-input v-else type="textarea" v-model="item.answer" placeholder="请输入答案"/>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="参考得分">
                  <span v-if="!isEdit">{{item.score}}分</span>
                  <el-input v-else type="number" v-model="item.score" placeholder="请输入题目分值"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="参考时间">
                  <span v-if="!isEdit">{{item.time}}分钟</span>
                  <el-input v-else type="number" v-model="item.time" placeholder="请输入答题参考时间，单位分钟"></el-input>
                </el-form-item>
              </el-col>
              <el-col style="text-align:right;margin-bottom:20px"><el-button type="default" @click="delItem(index)">删除</el-button></el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row style="text-align: center">
        <el-button type="primary" :disabled="grade.examAdd||loading" @click="saveExam" v-if="!isEdit">生成试卷</el-button>
        <el-button type="primary" :disabled="grade.examAdd||loading" @click="editExam" v-else>保存试卷</el-button>
      </el-row>
    </el-form>
  </div>
</template>
<script type="text/javascript">
import utils from "@/utils/index";
import common from "@/../server/common";
import "@/components/index";

export default {
  name: "list",
  data() {
    return {
      questionTypes: common.questionTypes,
      examTypes: common.examTypes,
      page_grade: common.page_grade,
      grade: {
        examAdd: !0,
        editExam: !0,
      },
      loading: false,
      question: {
        questionType: 4,
        question: "",
        options: [],
        answer: "",
        score: 2,
        time: 2
      },
      isEdit:this.$route.query.id,
      exam: {
        examType: 1,
        date: "",
        examTitle: "",
        totalScores: 0,
        time: 0,
        questionList: []
      },
      rules: {
        questionType: [
          {
            required: true,
            message: "请选择试题类型",
            trigger: "change"
          }
        ],
        question: [
          {
            required: true,
            message: "请输入问题",
            trigger: "blur"
          }
        ],
        options: [
          {
            required: true,
            message: "请添加选项",
            trigger: "change"
          },
          {
            validator: (rule, value, callback) => {
              if (value.length < 2 || !value[0] || !value[1]) {
                callback(new Error("请补全选项"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        answer: [
          {
            required: true,
            message: "请请入参考答案",
            trigger: "change"
          }
        ],
        score: [
          {
            required: true,
            message: "请请入该题分值",
            trigger: "blur"
          }
        ],
        time: [
          {
            required: true,
            message: "请请入答题参考时间",
            trigger: "blur"
          }
        ],
        examType: [
          {
            required: true,
            message: "请选择试卷类型",
            trigger: "change"
          }
        ],
        examTitle: [
          {
            required: true,
            message: "请输入试卷标题",
            trigger: "blur"
          }
        ],
        date: [
          {
            required: true,
            message: "请输入可以考试的时间",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    showOptions() {
      return [1, 2, 3].includes(this.question.questionType);
    }
  },
  mounted() {
    if(this.$route.query.id){
      utils.ajax.call(this,'/examDetail',this.$route.query,(data,err) => {
        if(!err){
          this.exam = data;
        }
      })
    }
  },
  methods: {
    addPreview() {
      this.$refs.form.validate(v => {
        if (v) {
          this.exam.questionList.push({
            ...this.question,
            options: this.showOptions ? this.question.options.filter(item=>item) : ""
          });
          this.exam.totalScores = this.exam.questionList
            .map(item => item.score)
            .reduce((x, y) => parseInt(x) + parseInt(y),0);
          this.exam.time = this.exam.questionList
            .map(item => item.time)
            .reduce((x, y) => parseInt(x) + parseInt(y),0);
          this.$refs["form"].resetFields();
        }
      });
    },
    delItem(index){
      this.exam.questionList.splice(index,1);
    },
    saveExam() {
      this.$refs.examForm.validate(async v => {
        if (v) {
          try {
            await this.$confirm("确认试题生成？测试者可在指定日期内完成答题");
            if (this.exam.questionList.length) {
              this.loading = true;
              utils.ajax.call(this, "/examAdd", this.exam, (data, err) => {
                this.loading = false;
                if (!err) {
                  this.$message.success("试题生成成功！");
                }
                this.$router.push("/exam/history");
              });
            } else {
              this.$message.error("请先添加试题！");
            }
          } catch (error) {}
        }
      });
    },
    editExam(){
      this.exam.totalScores = this.exam.questionList
        .map(item => item.score)
        .reduce((x, y) => parseInt(x) + parseInt(y),0);
      this.exam.time = this.exam.questionList
        .map(item => item.time)
        .reduce((x, y) => parseInt(x) + parseInt(y),0);
      this.$refs.examForm.validate(async v => {
        if (v) {
          try {
            await this.$confirm("确认保存试题？");
            if (this.exam.questionList.length) {
              this.loading = true;
              utils.ajax.call(this, "/examEdit", this.exam, (data, err) => {
                this.loading = false;
                if (!err) {
                  this.$message.success("试题生成成功！");
                }
                this.$router.push("/exam/history");
              });
            } else {
              this.$message.error("请先添加试题！");
            }
          } catch (error) {}
        }
      });  
    },
    addNewOption() {
      this.question.options.push("");
    },
  },
  mixins: [common.mixin]
};
</script>
<style>
.preview-title {
  padding: 20px;
  margin-bottom: 10px;
  text-align: center;
  font-weight: 600;
  border-bottom: 1px solid #eee;
}
.sub {
  font-size: 12px;
}
</style>
